export default "__VITE_ASSET__BG86W_g9__"